import axios from 'axios';
import utf8 from 'utf8';

//development
//const ROOT_SERV = "http://190.52.179.100/MauricioShop/";
//production
//const ROOT_SERV = "/static/";
//online test
const ROOT_SERV = "https://aulas.ceis.com.py/static/";
//ubuntu test
//const ROOT_SERV = "http://localhost/api-ceis/";

const SERVIDOR = `${ROOT_SERV}conn_bd.php`;

export const CAMBIAR_ACTUAL_MODULO = "CAMBIAR_ACTUAL_MODULO";
export const UPDATE_LOGIN_REQUEST = "UPDATE_LOGIN_REQUEST";
export const COURSE_LIST_REQUEST = "COURSE_LIST_REQUEST";
export const GET_TRANSACTION = "GET_TRANSACTION";
export const UNLOGIN_REQUEST = "UNLOGIN_REQUEST";
export const COURSE_REQUEST = "COURSE_REQUEST";
export const MODULE_REQUEST = "MODULE_REQUEST";
export const ADQUIRIR_CURSO = "ADQUIRIR_CURSO";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const GET_COMPLETOS = "GET_COMPLETOS";
export const MARCAR_LEIDO = "MARCAR_LEIDO";
export const HEAD_CHANGE = "HEAD_CHANGE";
export const REMOVE_CAR = "REMOVE_CAR";
export const SINGLE_BUY = "SINGLE_BUY";
export const CLEAR_CAR = "CLEAR_CAR";
export const ADD_CAR = "ADD_CAR";
export const SIGN_UP = "SIGN_UP";


export function cambiarActualModulo(contenidoActual){
  return {
    type: CAMBIAR_ACTUAL_MODULO,
    payload: contenidoActual
  }
}

export function loguear(usuario, contraseña){
  let req = axios.post(SERVIDOR, {
  	"peticion": "login",
  	"datos": {
  		"email": usuario,
  		"password": contraseña
  	}
  });
  return {
    type: LOGIN_REQUEST,
    payload: req
  };
}

export function updateEstudiante(id, datosEstudiante){
  datosEstudiante['id'] = id;
  datosEstudiante['action'] = "update";

  let req = axios.post(SERVIDOR, {
      "peticion": "set_usuario",
      "datos": datosEstudiante
  });

  return {
    type: UPDATE_LOGIN_REQUEST,
    payload: req
  }
}

export function insertEstudiante(datosEstudiante){
  datosEstudiante['action'] = "insert";

  let keys = Object.keys(datosEstudiante);
  keys.forEach((key)=>{
    datosEstudiante[key] = utf8.encode(datosEstudiante[key]);
  });

  let req = axios.post(SERVIDOR, {
      "peticion": "set_usuario",
      "datos": datosEstudiante
  });
  return {
    type: SIGN_UP,
    payload: req
  }
}

export function recuperarLogueo(token){
  let req = axios.post(SERVIDOR, {
  	"peticion": "relogin",
  	"datos": {
  		"token": token
  	}
  });
  return {
    type: LOGIN_REQUEST,
    payload: req
  };
}

export function cerrarSesion(){
  return {
    type: UNLOGIN_REQUEST,
    payload: {}
  }
}

export function getModulo(idmodulo, idalumno=null){
  let req = null;
  if(idalumno==null) {
    req = axios.post(SERVIDOR, {
      peticion: "get_modulo",
    	datos: { idmodulo }
    });
  } else {
    req = axios.post(SERVIDOR, {
      peticion: "get_modulo",
    	datos: { idmodulo, idalumno }
    });
  }
  return {
    type: MODULE_REQUEST,
    payload: req
  }
}

export function getCompletos(idmodulo, idalumno){
  let req = axios.post(SERVIDOR, {
    peticion: "get_completos",
    datos: { idmodulo, idalumno }
  });
  return {
    type: GET_COMPLETOS,
    payload: req
  };
}

export function adquirirCurso(curso, alumno){
  let req = axios.post(SERVIDOR, {
    peticion: "adquirir_curso",
    datos: { idcurso: curso.id, idalumno: alumno.id }
  });

  return {
    type: ADQUIRIR_CURSO,
    payload: req
  };

}

export function getCurso(idcurso, idalumno=null){
  if(idcurso===null)
    return {
      type: COURSE_REQUEST,
      payload: { data: null }
    };
  let req = null;
  if(idalumno==null) {
    req = axios.post(SERVIDOR, {
      peticion: "get_curso",
      datos: { idcurso }
    });
  } else {
    req = axios.post(SERVIDOR, {
      peticion: "get_curso",
      datos: { idcurso, idalumno }
    });
  }

  return {
    type: COURSE_REQUEST,
    payload: req
  };

}

export function getListadoCursos(query=null){
    let datos = {};
    if (query!=null) {
        datos['query'] = query;
    }

    let req = axios.post(SERVIDOR, {
      peticion: "get_listado_cursos",
    	datos
    });
    return {
      type: COURSE_LIST_REQUEST,
      payload: req
    }
}

export function actualizarEncabezado(texto){
  return {
    type: HEAD_CHANGE,
    payload: texto
  }
}

export function agregarCarrito(producto){
  return {
    type: ADD_CAR,
    payload: producto
  }
}
export function quitarCarrito(idproducto){
  return {
    type: REMOVE_CAR,
    payload: idproducto
  }
}
export function limpiarCarrito(){
  return {
    type: CLEAR_CAR,
    payload: {}
  }
}

export function singleBuy(alumno, cursos, total){
  let req = axios.post(`${ROOT_SERV}single_buy/index.php`, {
  	"transaccion": {
      alumno, cursos, total
    }
  });
  return {
    type: SINGLE_BUY,
    payload: req
  };
}
export function getTransactionDetails(idcompra){
  let req = axios.post(SERVIDOR, {
  	peticion: "get_transaction",
    datos: { id: idcompra }
  });
  return {
    type: GET_TRANSACTION,
    payload: req
  };
}

export function marcarLeido(idalumno, idcontenido){
  let req = axios.post(SERVIDOR,
    {
      peticion: "marcar_completo",
      datos: { idalumno, idcontenido }
    }
  );
  return {
    type: MARCAR_LEIDO,
    payload: req
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js